<template lang="pug">
.v-catalog-specialist.catalog-specialist(v-if="data" )
	.container
		h1.catalog-specialist__title(v-if="data.title" ) {{ data.title }}
		.catalog-specialist__fields(v-if="data.filters" )
			.catalog-specialist__field(v-for="(field ,index) in data.filters" :key="index")
				v-field.tabs-nav(:field="field" v-model="field.value" @update:model-value="filterChange(field, $event)")
				.catalog-specialist__total(v-if="field.variables" )
					.catalog-specialist__total-value(v-if="data.items && data.items.length && data.page.count" ) {{ data.page.count }}
					.catalog-specialist__total-text(v-if="field.variables.specialist && data.items" ) &nbsp;{{ field.variables.specialist }}
		.catalog-specialist__list(v-if="data.items" )
			a.catalog-specialist__list-item.card-specialist.flc(v-for="(item, index) in data.items" :key="index" :href="item.href")
				.card-specialist__logo(v-if="item.logo")
					img.card-specialist__image(
						:src="item.logo?.src"
						:alt="item.logo?.alt")
				.card-specialist__name
					.card-specialist__title(v-if="item.title" ) {{ item.title }}
					.card-specialist__subtitle(v-if="item.subtitle" ) {{ item.subtitle }}
				.card-specialist__region(v-if="item.region" ) {{ item.region }}
				.card-specialist__announcement(v-if="item.variables" )
					.card-specialist__announcement-value(v-if="item.number" ) {{ item.number }}
					.card-specialist__announcement-text(v-if="item.variables.announcement && item.number" ) &nbsp;{{ item.variables.announcement }}
		.catalog-specialist__nav
			v-page-nav(:page="data.page" :variables="data.variables" :limits="data.limits" @navigate="navigate")



</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	mixins: [sourceMixin, formattingMixin],

	data() {
		return {
			data: null,
			page: null,
			filter: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.page = this.data.page;
			this.data.filters.forEach(field => this.filter = {...this.filter, ...{[field.name]: field.value}})
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					page: this.page,
					filter: this.filter
				}
			}, dataSetOptions);
		},

		filterChange(field, value) {
			this.page.offset = 0;
			this.filter = {...this.filter, ...{[field.name]: value}}
			this.requestDataLoad();
		},

		navigate(page) {
			this.page.offset = page.offset;
			this.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},
	}
};
</script>